import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className={styles.container}>
      <Link to="/nova-solicitacao" className={styles.backLink}>
        <FontAwesomeIcon icon={faArrowLeft} /> Voltar
      </Link>

      <div className={styles.header}>
        <FontAwesomeIcon icon={faShieldHalved} className={styles.icon} />
        <h1 className={styles.title}>Política de Privacidade</h1>
        <p className={styles.subtitle}>
          Em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018)
        </p>
      </div>

      <section className={styles.section}>
        <h2>1. Dados coletados</h2>
        <p>
          Para processar sua solicitação de serviço de iluminação pública, coletamos os seguintes dados:
        </p>
        <ul>
          <li>Nome completo</li>
          <li>CPF</li>
          <li>Data de nascimento</li>
          <li>E-mail</li>
          <li>Telefone (WhatsApp)</li>
          <li>Endereço (logradouro, número, bairro)</li>
          <li>Coordenadas GPS do poste</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>2. Finalidade do tratamento</h2>
        <p>
          Os dados pessoais fornecidos são utilizados exclusivamente para:
        </p>
        <ul>
          <li>Registrar e processar sua solicitação de reparo ou manutenção da iluminação pública</li>
          <li>Permitir que você acompanhe o andamento da solicitação pelo número de protocolo</li>
          <li>Possibilitar que a equipe técnica localize o poste com precisão via coordenadas GPS</li>
          <li>Entrar em contato caso sejam necessárias informações adicionais sobre a solicitação</li>
        </ul>
        <p>
          Seus dados <strong>nunca</strong> serão utilizados para fins comerciais, publicitários ou de marketing.
        </p>
      </section>

      <section className={styles.section}>
        <h2>3. Armazenamento e segurança</h2>
        <ul>
          <li>O CPF é armazenado de forma <strong>criptografada</strong> (AES-256-GCM), não sendo legível por pessoas não autorizadas</li>
          <li>Os dados são armazenados em banco de dados seguro sob responsabilidade da Prefeitura Municipal de Pesqueira</li>
          <li>Medidas técnicas e administrativas são adotadas para proteger seus dados contra acessos não autorizados</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>4. Compartilhamento de dados</h2>
        <p>
          Seus dados não são compartilhados com terceiros. O acesso é restrito aos servidores públicos
          municipais designados ao atendimento de solicitações de iluminação pública.
        </p>
      </section>

      <section className={styles.section}>
        <h2>5. Direitos do titular (Art. 18, LGPD)</h2>
        <p>Você tem os seguintes direitos garantidos por lei:</p>
        <ul>
          <li><strong>Confirmação</strong> da existência de tratamento dos seus dados</li>
          <li><strong>Acesso</strong> aos dados armazenados</li>
          <li><strong>Correção</strong> de dados incompletos, inexatos ou desatualizados</li>
          <li><strong>Eliminação</strong> dos dados após a finalidade ser atingida ou mediante solicitação</li>
          <li><strong>Informação</strong> sobre compartilhamento e finalidade do tratamento</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>6. Tempo de retenção</h2>
        <p>
          Seus dados serão mantidos apenas pelo período necessário para processar sua solicitação
          e cumprir obrigações legais. Após a conclusão definitiva da solicitação, os dados poderão
          ser anonimizados ou eliminados, respeitando prazos legais de arquivamento público.
        </p>
      </section>

      <section className={styles.section}>
        <h2>7. Contato</h2>
        <p>Para exercer seus direitos ou esclarecer dúvidas sobre o tratamento dos seus dados:</p>
        <ul>
          <li><strong>Secretaria de Serviços Públicos</strong></li>
          <li>Prefeitura Municipal de Pesqueira — PE</li>
          <li>E-mail: pmpsictec@gmail.com</li>
        </ul>
      </section>

      <p className={styles.effectiveDate}>Última atualização: Junho de 2026</p>
    </div>
  );
};

export default PrivacyPolicy;
